import React from 'react';
import ChunkForm from './ChunkForm';

interface Document {
  id: number;
  name: string;
}

interface Chunk {
  id: number;
  page_number?: number;
  citation?: string;
  content?: string;
  embed?: string;
  metadata?: Record<string, any>;
}

interface ChunkEditProps {
  document: Document;
  chunk: Chunk;
  errors: Record<string, string[]>;
}

export default function ChunkEdit({ document, chunk, errors = {} }: ChunkEditProps) {
  return (
    <ChunkForm 
      document={document}
      chunk={chunk} 
      isEdit={true} 
      errors={errors}
    />
  );
}